import React from 'react';

import { AssetSelectedTypeMap } from '../../../../store/product/types';
import { ProductsConstantsType, ProductsType } from '../DynamicAsset/constants';

import { CoesButton } from './products/Coes';
import { DirectTreasuryButton } from './products/DirectTreasury';
import { EquityButton } from './products/Equity';
import { FixedIncomeButton } from './products/FixedIncome';
import { FundsButton } from './products/Funds';

export interface ProductButtonProps<T extends keyof AssetSelectedTypeMap> {
  id: T;
  offer: AssetSelectedTypeMap[T];
  isDisabled?: boolean;
  productContextConstant: ProductsConstantsType;
}

export type ProductsButtonType = {
  [K in ProductsType]: React.FC<ProductButtonProps<K>>;
};

export const DynamicButton: React.FC<ProductButtonProps<ProductsType>> = (props) => {
  switch (props.id) {
    case 'fixedIncome':
      return <FixedIncomeButton {...(props as ProductButtonProps<'fixedIncome'>)} />;

    case 'equity':
      return <EquityButton {...(props as ProductButtonProps<'equity'>)} />;

    case 'funds':
      return <FundsButton {...(props as ProductButtonProps<'funds'>)} />;

    case 'directTreasury':
      return <DirectTreasuryButton {...(props as ProductButtonProps<'directTreasury'>)} />;

    case 'coes':
      return <CoesButton {...(props as ProductButtonProps<'coes'>)} />;

    default:
      return null;
  }
};
